import React, { useEffect, useState } from 'react'
import AddSvg from '../../../assets/images/add.svg'
import ChevronSvg from '../../../assets/images/chevron.svg'
import { ResponsiveSVG } from 'ui/acro'
import styled from 'styled-components'
import Text from 'ui/acro/typography/Text'
import Drawer from '../../components_v2/Drawer/Drawer'
import { Button } from 'react-bootstrap'
import { axios } from 'api'
import isEqual from 'lodash.isequal'
import { camelToSnake } from 'utils'

const MyPlaylistText = styled(Text)({
  fontSize: ['16px'],
  fontFamily: 'Proxima-nova',
  color: '#000',
  fontStyle: 'normal',
  fontWeight: '600',
  lineHeight: '24px',
  letterSpacing: '0.352px',
  margin: '24px 0px 0px 0px'
})

const NewPlaylistButton = styled(Button)`
  font-size: 16px;
  font-family: Proxima-nova;
  display: flex;
  border-radius: 25px;
  padding: 8px 24px;
  border: 1px solid #a3a3a3;
  text-transform: uppercase;
  color: #000;
  background: #fff;
  font-weight: 500;

  &:hover {
    background: #ebebeb;
  }
`

const PlaylistBack = styled.button`
  font-size: 18px;
  color: #000;
  font-family: 'Proxima-Nova';
  font-style: normal;
  font-weight: 600;
  line-height: 135%;
  display: flex;
  border-width: 0;
  margin-left: -18px;
  text-transform: uppercase;
  background: #fff;
`

const FooterWrapper = styled.div`
  position: fixed;
  width: calc(100% - 64px);
  margin-bottom: 25px;
  margin-top: 25px;
`

const PlayListName = styled.input`
  color: #000;
  font-family: 'Proxima-Nova';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.352px;
  padding: 12px 16px;
  border: 1px solid #a3a3a3;
  width: 100%;
  margin-top: 24px;
`

const PlayListDesc = styled.textarea`
  color: #000;
  font-family: 'Proxima-Nova';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.352px;
  padding: 12px 16px;
  border: 1px solid #a3a3a3;
  width: 100%;
  margin-top: 24px;
  resize: none;
  height: 110px;
`

const SavePlaylistButton = styled(Button)`
  font-size: 18px;
  font-family: Proxima-nova;
  text-transform: uppercase;
  color: ${(props) => (props.disabled ? '#4c4c4c' : '#fff')};
  background: ${(props) => (props.disabled ? '#fff' : '#000')};
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.9px;
  padding: 12px 32px;
  width: 100%;
  border: 1px solid #cccccc;
  border-radius: 4px;

  &:hover {
    background: #ebebeb;
  }
`

const PlayListDrawer = ({
  isOpen,
  onClose,
  planEntryId,
  playlists = [],
  onSuccess
}) => {
  const [newPlayList, setNewPlayList] = useState(true)
  const [playList, setPlayList] = useState([])
  const [selectedPlay, setSelectedPlay] = useState(playlists)
  const [playListTitle, setPlayListTitle] = useState(
    `New Playlist ${new Date().toLocaleDateString('en-GB')}`
  )

  const [playListDesc, setPlayListDesc] = useState('')

  useEffect(() => {
    if (isOpen && !isEqual(selectedPlay, playlists)) {
      setSelectedPlay(playlists)
    }
  }, [playlists, isOpen])

  useEffect(() => {
    isOpen && fetchData()
  }, [newPlayList, isOpen])

  const fetchData = async () => {
    const params = {
      scope: 'class_page',
      field: 'date',
      direction: 'desc'
    }
    try {
      const res = await axios.get(`playlists/me`, { params })
      if (res.status === 200) {
        setPlayList(res.data)
      }
    } catch (e) {
      console.error(e)
    }
  }

  const handleChange = (e) => {
    const { value, checked } = e.target

    if (checked) {
      setSelectedPlay([...selectedPlay, value])
    } else {
      setSelectedPlay(selectedPlay.filter((e) => e !== value))
    }
  }

  const handleDescChange = (e) => {
    setPlayListDesc(e.target.value)
  }

  const handleTitleChange = (e) => {
    setPlayListTitle(e.target.value)
  }

  const savePlayListHandler = async () => {
    try {
      const res = await axios.post(`playlists/update_class_playlist`, {
        plan_entry_id: planEntryId,
        playlist_ids: selectedPlay
      })
      if (res.status === 200) {
        if (Array.isArray(res?.data?.ga4Events)) {
          res?.data?.ga4Events?.forEach((evt) => {
            window.dataLayer?.push(camelToSnake(evt))
          })
        }
        onClose()
        if (onSuccess) {
          onSuccess(selectedPlay)
        }
      }
    } catch (e) {
      console.error(e)
    }
  }

  const createPlayList = async () => {
    try {
      const res = await axios.post(`playlists`, {
        title: playListTitle,
        description: playListDesc
      })

      if (res.status === 200) {
        setSelectedPlay([...selectedPlay, res?.data?.uuid])
        setNewPlayList(true)
      }
    } catch (e) {
      console.error(e)
    }
  }

  const closeDrawer = () => {
    onClose()
    setNewPlayList(true)
  }
  return (
    <Drawer
      isOpen={isOpen}
      title='Add to Playlist'
      onClose={() => {
        closeDrawer()
      }}
    >
      <div>
        {newPlayList ? (
          <>
            <NewPlaylistButton
              onClick={() => {
                setNewPlayList(false)
                setPlayListTitle(
                  `New Playlist ${new Date().toLocaleDateString('en-GB')}`
                )
              }}
            >
              <ResponsiveSVG
                SVG={AddSvg}
                style={{
                  cursor: 'pointer'
                }}
                width='34px'
                height='19px'
              />
              <div>New Playlist</div>
            </NewPlaylistButton>
            <MyPlaylistText>My Playlists</MyPlaylistText>
            <div className='radioWrapper'>
              {playList?.map((item) => (
                <label class='radioContainer' key={item.uuid}>
                  {item.title}
                  <input
                    type='checkbox'
                    name='checkbox'
                    value={item.uuid}
                    checked={selectedPlay.includes(item.uuid)}
                    onChange={handleChange}
                  />
                  <span class='checkmark'></span>
                </label>
              ))}
            </div>
            <FooterWrapper>
              <SavePlaylistButton
                onClick={savePlayListHandler}
                disabled={isEqual(playlists, selectedPlay)}
              >
                Save
              </SavePlaylistButton>
            </FooterWrapper>
          </>
        ) : (
          <>
            <PlaylistBack onClick={() => setNewPlayList(true)}>
              <ResponsiveSVG
                SVG={ChevronSvg}
                style={{
                  cursor: 'pointer'
                }}
                width='24px'
                height='24px'
              />
              <div>New Playlist</div>
            </PlaylistBack>
            <div className='createPlayListWrapper'>
              <PlayListName
                type='text'
                value={playListTitle}
                onChange={handleTitleChange}
              />
              <PlayListDesc
                placeholder='Description (Max 500 Characters)'
                onChange={handleDescChange}
                value={playListDesc}
              ></PlayListDesc>
            </div>
            <FooterWrapper>
              <SavePlaylistButton onClick={createPlayList}>
                Create new Playlist
              </SavePlaylistButton>
            </FooterWrapper>
          </>
        )}
      </div>
    </Drawer>
  )
}
export default PlayListDrawer
